import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ajax-loading',
  templateUrl: './ajax-loading.component.html'
})
export class AjaxLoadingComponent implements OnInit {

  constructor(
    ){
  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./src/app/components/partials/ajax-loding/ajax-loading.component.ts